import angular from 'angular';
import moment from 'moment';

angular
  .module('cxInvoicing')
  .controller('WriteOffInternallyDialogCtrl', [
    '$element',
    'close',
    'appUrls',
    'invoice',
    '$http',
    'flySvc',
    writeOffInternallyDialogCtrl,
  ]);

function writeOffInternallyDialogCtrl($element, close, appUrls, invoice, $http, flySvc) {
  var vm = this;
  vm.saving = false;
  vm.invoiceDate = null;
  vm.remark = '';

  vm.$onInit = function() {
    vm.invoiceDate = moment
      .utc(invoice.date || undefined)
      .startOf('day')
      .toDate();
  };
  vm.save = function() {
    if (vm.saving || !vm.invoiceDate) return;
    vm.saving = true;
    return $http
      .post(`${appUrls.api}/api/draftinvoice/WriteOffInternally/${invoice.id}`, {
        invoiceDate: vm.invoiceDate.ISO(),
        remark: vm.remark || null,
      })
      .then(
        function() {
          vm.saving = false;
          $element.modal('hide');
          close(true, 500);
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
